import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-charger-status",
    templateUrl: "./charger-status.component.html",
    styleUrls: ["./charger-status.component.scss"],
})

export class ChargerStatusComponent implements OnInit, OnDestroy {
    charging: any = false; // Session

    chargerId = "";
    stationId = "";
    connectorId = "";
    chargerData: any[] = [];
    // consumptionData: any = {};

    meterCurrentValue = "0.000";
    consumptionPerUnit = "10";

    currentBalance = null;

    chargerType = "";
    connectorStatus = "";
    connectorTypeName = "";
    lastPing = "";
    stationName = "";

    userId = "";
    mobileNo = "";
    transactionId = "";
    setIntervalTransaction: any = null;

    private statusInterval: any = null;

    elapsedSeconds: number = 0;
    formattedTime: string = "00:00:00";

    constructor(
        private configService: FuseConfigService,
        private snackBar: MatSnackBar,
        private router: Router,
        private spinner: NgxSpinnerService
    ) {
        this.configService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.userId = sessionStorage.getItem("web_user_id") ?? "";
        this.mobileNo = sessionStorage.getItem("web_mobile") ?? "";

        if (!this.userId && !this.mobileNo) {
            this.router.navigate(["/web-login"]);
        }

        const rawText = sessionStorage.getItem("charger_data");
        if (!rawText) {
            this.router.navigate(["/scan-charger"]);
            return;
        }

        const [chargerId, stationId, connectorId] = rawText.trim().split(/\s+/);
        this.chargerId = chargerId;
        this.stationId = stationId;
        this.connectorId = connectorId;

        setInterval(() => {
            this.charging = sessionStorage.getItem("charging") === "true";
        }, 500);

        this.getCurrentBalanceByUserID();
        this.fetchConnectorStatus();
        this.statusInterval = setInterval(() => {
            if (this.charging) {
                this.getActiveTransactionId();
            }

            this.transactionId = sessionStorage.getItem("transactionId");
            this.fetchConnectorStatus();
        }, 5000);

        setInterval(() => {
            if (this.charging) {
                this.updateElapsedTime();

                if (Number(this.currentBalance) <= (Number(this.meterCurrentValue) * Number(this.consumptionPerUnit))) {
                    this.stopCharging();
                }
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        if (this.statusInterval) clearInterval(this.statusInterval);
        if (this.setIntervalTransaction)
            clearInterval(this.setIntervalTransaction);
    }

    getCurrentBalanceByUserID(): void {
        // const url = `https://cmsapi.vmatic.co.in/user/app/getCurrentBalanceByUserID/${this.userId}`;
        // const url = `http://103.151.107.88:5205/user/app/getCurrentBalanceByUserID/${this.userId}`;
        const url = `${environment.API_URL2}/user/app/getCurrentBalanceByUserID/${this.userId}`;

        fetch(url)
            .then((res) => res.json())
            .then((res) => {
                if (res.status) {
                    this.currentBalance = res?.data?.currentBalance;
                }
            })
            .catch((err) => {
                console.error("Fetch connector status error:", err);
            });
    }

    fetchConnectorStatus(): void {
        // const url = `https://cmsapi.vmatic.co.in/chrgStation/gtConnectorStatusBySCC/${this.stationId}/${this.chargerId}/${this.connectorId}`;
        // const url = `http://103.151.107.88:5205/chrgStation/gtConnectorStatusBySCC/${this.stationId}/${this.chargerId}/${this.connectorId}`;
        const url = `${environment.API_URL2}/chrgStation/gtConnectorStatusBySCC/${this.stationId}/${this.chargerId}/${this.connectorId}`;

        fetch(url)
            .then((res) => res.json())
            .then((res) => {
                if (!res?.data?.[0]) return;

                const info = res.data[0];
                this.chargerData = res.data;
                this.consumptionPerUnit = info.consumption_amt_per_unit;
                this.chargerType = info.charger_type;
                this.connectorStatus = info.connector_current_status;
                this.connectorTypeName = info.connector_type_name;
                this.lastPing = info.last_ping_datetime;
                this.stationName = info.station_name;

                if (info.connector_current_status === "Charging") {
                    sessionStorage.setItem("charging", "true");
                    setTimeout(() => {
                        if (!this.charging) {
                            const now = new Date();
                            const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
                            const istDate = new Date(now.getTime() + istOffset);
                            const istISOString = istDate
                                .toISOString()
                                .replace("Z", "+05:30");

                            sessionStorage.setItem("startTime", istISOString);
                        }
                    }, 1000);
                } else {
                    sessionStorage.setItem("charging", "false");

                    const now = new Date();
                    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
                    const istDate = new Date(now.getTime() + istOffset);
                    const istISOString = istDate
                        .toISOString()
                        .replace("Z", "+05:30");

                    sessionStorage.setItem("startTime", istISOString);

                    if (info.connector_current_status === "Faulted") {
                        // this.stopCharging();
                        setTimeout(() => {
                            this.generateBill();
                        }, 5000);
                        this.clearTransactionInterval();
                    } else if (info.connector_current_status === "Available") {
                        this.clearTransactionInterval();
                    }
                }
            })
            .catch((err) => {
                console.error("Fetch connector status error:", err);
            });
    }

    async playCharging(): Promise<void> {
        const payload = this.buildChargingPayload("START_CHARGING");
        this.spinner.show();
        setTimeout(() => {
            this.spinner.hide();
        }, 10000);

        try {
            const res = await fetch(
                // "https://cmsmidapi.vmatic.co.in/remoteTransaction",
                // "http://103.151.107.88:5206/remoteTransaction",
                `${environment.API_URL3}/remoteTransaction`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await res.json();
            this.showMessage(result.message);

            if (result.status) {
                this.spinner.hide();
                sessionStorage.setItem("charging", "true");
            } else {
                sessionStorage.setItem("charging", "false");
                this.clearTransactionInterval();
            }
        } catch (err) {
            console.error("Start charging error:", err);
            this.showMessage("Something went wrong. Please try again.");
        }
    }

    async stopCharging() {
        const payload = this.buildChargingPayload("STOP_CHARGING");
        this.spinner.show();
        setTimeout(() => {
            this.spinner.hide();
        }, 5000);
        try {
            const res = await fetch(
                // "https://cmsmidapi.vmatic.co.in/remoteTransaction",
                // "http://103.151.107.88:5206/remoteTransaction",
                `${environment.API_URL3}/remoteTransaction`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await res.json();
            this.showMessage(result.message);

            if (result.status) {
                this.spinner.hide();
                sessionStorage.setItem("charging", "false");
                this.clearTransactionInterval();
                setTimeout(() => {
                    this.generateBill();
                }, 5000);
            }
        } catch (err) {
            console.error("Stop charging error:", err);
            this.showMessage("Something went wrong. Please try again.");
        }
    }

    async getActiveTransactionId(): Promise<void> {
        try {
            const res = await fetch(
                // `https://cmsmidapi.vmatic.co.in/getActiveTransactionId/${this.chargerId}/${this.connectorId}`
                `http://103.151.107.88:5206/getActiveTransactionId/${this.chargerId}/${this.connectorId}`
            );
            const result = await res.json();

            if (result.status) {
                sessionStorage.setItem("transactionId", result.data);
                if (!this.setIntervalTransaction) {
                    this.setIntervalTransaction = setInterval(
                        () => this.fetchTransactionDetails(),
                        5000
                    );
                }
            }
        } catch (err) {
            console.error("Transaction ID fetch error:", err);
            this.showMessage("Failed to retrieve transaction ID.");
        }
    }

    async fetchTransactionDetails(): Promise<void> {
        if (!this.transactionId) return;

        try {
            const res = await fetch(
                // `https://cmsapi.vmatic.co.in/api-v2/app/getMeterCurrentValue/${this.transactionId}`
                // `http://103.151.107.88:5205/api-v2/app/getMeterCurrentValue/${this.transactionId}`
                `${environment.API_URL2}/api-v2/app/getMeterCurrentValue/${this.transactionId}`
            );
            const result = await res.json();

            if (result.status && result.data[0].data) {
                this.meterCurrentValue = Number(
                    result.data[0].data / 1000
                ).toFixed(3);
            }
        } catch (err) {
            console.error("Fetch meter value error:", err);
            this.showMessage("Unable to fetch meter value.");
        }
    }

    private buildChargingPayload(command: "START_CHARGING" | "STOP_CHARGING") {
        return {
            app_version: "1.4",
            booking_id: "1",
            charger_id: this.chargerId,
            charger_sr_no: this.chargerId,
            command,
            command_source: "web-app",
            connector: this.connectorId,
            device_id: "",
            id_tag: "",
            id_tag_type: "RF_ID",
            mobile_no: this.mobileNo,
            os_version: "",
            station_id: this.stationId,
            user_id: this.userId,
            vehicle_id: "",
            vehicle_number: "",
        };
    }

    private clearTransactionInterval(): void {
        if (this.setIntervalTransaction) {
            clearInterval(this.setIntervalTransaction);
            this.setIntervalTransaction = null;
        }
    }

    private showMessage(message: string): void {
        this.snackBar.open(message, "Dismiss", { duration: 5000 });
    }

    private updateElapsedTime(): void {
        let now = new Date();
        let startTimeString = sessionStorage.getItem("startTime");
        let startTime = new Date(startTimeString);

        let elapsedMs = now.getTime() - startTime.getTime();
        this.elapsedSeconds = Math.floor(elapsedMs / 1000);
        this.formattedTime = this.formatTime(this.elapsedSeconds);
    }

    formatTime(totalSeconds: number): string {
        const hours = Math.floor(totalSeconds / 3600)
            .toString()
            .padStart(2, "0");
        const minutes = Math.floor((totalSeconds % 3600) / 60)
            .toString()
            .padStart(2, "0");
        const seconds = (totalSeconds % 60).toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    }

    formatSecondsToHHMMSS(totalSeconds: any) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        // Pad with leading zeros
        const pad = (num) => String(num).padStart(2, "0");

        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    async generateBill(): Promise<void> {
        try {
            const res = await fetch(
                // `https://cmsapi.vmatic.co.in/api-v2/app/getConsumptionByTranscationId/${this.transactionId}`
                // `http://103.151.107.88:5205/api-v2/app/getConsumptionByTranscationId/${this.transactionId}`
                `${environment.API_URL2}/api-v2/app/getConsumptionByTranscationId/${this.transactionId}`
            );
            const result = await res.json();

            if (
                result?.status &&
                Array.isArray(result.data) &&
                result.data.length
            ) {
                const [data] = result.data;
                const consumptionData = {
                    start_time: data.start_time,
                    stop_time: data.stop_time,
                    energy_consumed: Number(data.energy_consumed) / 1000,
                    duration_in_minutes: this.formatSecondsToHHMMSS(
                        data.duration
                    ),
                };

                sessionStorage.setItem(
                    "consumptionData",
                    JSON.stringify(consumptionData)
                );
                await this.updateBalance();
            } else {
                this.showMessage("Invalid transaction data.");
            }
        } catch (err) {
            console.error("Transaction ID fetch error:", err);
            this.showMessage("Failed to retrieve transaction data.");
        }
    }

    async updateBalance(): Promise<void> {
        try {
            const sessionData = sessionStorage.getItem("consumptionData");

            if (!sessionData) {
                this.showMessage("No consumption data found.");
                return;
            }

            const consumptionData = JSON.parse(sessionData);
            const consumedEnergy = Number(consumptionData.energy_consumed);
            const currentBalance = Number(this.currentBalance);
            const unitRate = Number(this.consumptionPerUnit);

            const newBalance = currentBalance - (consumedEnergy * unitRate);

            const payload = {
                userId: this.userId,
                balance: newBalance,
            };

            const res = await fetch(
                // "https://cmsapi.vmatic.co.in/user/app/updateUserBalanceByUserID",
                // "http://103.151.107.88:5205/user/app/updateUserBalanceByUserID",
                `${environment.API_URL2}/user/app/updateUserBalanceByUserID`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await res.json();
            
            if (result?.status) {
                this.getCurrentBalanceByUserID();
                sessionStorage.setItem("amount", `${newBalance.toFixed(2)}`)
                sessionStorage.setItem("consuptionBalance", `${(consumedEnergy * unitRate).toFixed(2)}`)
                this.router.navigate(["/charging-summary"]);
            } else {
                this.showMessage(
                    result?.message || "Failed to update balance."
                );
            }
        } catch (err) {
            console.error("Bill generation error:", err);
            this.showMessage("Something went wrong while generating the bill.");
        }
    }
}
